export const GTM_ID = 'GTM-KQQGFNX';
export const GTM_ID_DEV = 'GTM-5NHNTRH';

export const GTM_PURCHASE_EVENT = 'PURCHASE';
export const GTM_ADD_PAYMENT_INFO_EVENT = 'ADD_PAYMENT_INFO';
export const GTM_EFFECTIVE_PLAY_EVENT = 'EFFECTIVE_PLAY';
